
import { defineComponent } from 'vue';
import { SocialMention, SocialMediaSource, SocialMediaShape } from '@/models/Social/social-mention';

export default defineComponent({
    props: {
        kStrings:{
            type: Object,
            default: () => {
                return {
                    publications: 'Publications',
                    followers: 'Followers',
                    following: 'Following',
                    follow: 'Follow',
                    seeTransaction: 'See Transaction',
                    seeOriginal: 'See Original',
                }
            }
        },
        hideText: {
            type: Boolean,
            default: false
        },
        mention:{
            type: SocialMention,
            default: () => new SocialMention(undefined, undefined)
        },
        isAppStore:{
            type: Boolean,
            default: false
        },
        showLike:{
            type: Boolean,
            default: true
        },
        clubMode: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return {
            translate: false,
            showLoader: false,
            mute: true,
            allText: false,
            selectedVideo: false
        }
    },
    watch:{
        sources:{
            handler(){
                let firstSource = this.sources[0] ?? null;
                if(firstSource){
                    this.selectedVideo = firstSource.type == 'video';
                }
            },
            immediate: true
        }
    },
    computed:{
        sources(): Array<SocialMediaSource>{
            return this.mention?.post.media?.sources ?? [];
        },
        text(): string|undefined{
            return !this.translate ? this.mention.post.text : this.mention.post.transaction;
        },
        likesInfo(): object|undefined{
            return this.mention?.like?.params() ?? undefined;
        },
        isFull(): boolean{
            return this.mention.post?.media?.shape == SocialMediaShape.VERTICAL;
        }
    },
    methods: {
        close(){
            this.showLoader = true;
        },
        likeChange(info: any){
            let lastState = this.mention.like.liked;
            this.mention.like.liked = info?.liked ?? false;
            if(lastState !== this.mention.like.liked){
                return this.mention.like.liked ? this.mention.like.num++ : this.mention.like.num--;
            }
        },
        muteClick(){
            this.mute = !this.mute;
            let video = this.$el.querySelector('video');
            try{
                if(video){
                    video.muted = this.mute;
                }
            }catch(e){}
        },
        mediaChange(value: any){
            let isVideo = value?.isVideo ?? false;
            this.selectedVideo = isVideo;
        },
        actionClick(type: string){
            this.$emit('action', type);
        },
        videoPlay(){
            let video = this.$el.querySelector('video');
            if(video){
                this.$emit('videoPlay');
                this.mute = video.muted ?? false;
            }
        },
        imgLoad(){
            this.$emit('imgLoad');
        }
    }
});
